import { render, staticRenderFns } from "./shixi_ngz.vue?vue&type=template&id=1af96143&"
import script from "./shixi_ngz.vue?vue&type=script&lang=js&"
export * from "./shixi_ngz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports